<div #modalBtnShow>
  <ng-content select=".modal-button-show"> </ng-content>
</div>

<div
  bsModal
  #childModal="bs-modal"
  class="modal fade"
  [ngClass]="{ 'come-from-modal': isModalFromRight || isModalFromLeft, right: isModalFromRight, left: isModalFromLeft }"
  tabindex="-1"
  role="dialog"
  [config]="{ backdrop: hasBackdrop, ignoreBackdropClick: ignoreBackdropClick }"
>
  <div
    class="modal-dialog"
    [ngClass]="{
      'modal-sm': isSmallModal,
      'modal-708-px': isModalForTypeOut,
      'modal-lg': isLargeModal,
      'modal-xl': isExtraLargeModal,
      'w-100': isFullWidth,
      'modal-center': isModalInModal,
    }"
    [ngStyle]="
      isModalForProductChoose
        ? {
            position: 'fixed',
            'top.px': 30,
            'height.px': modalBtnShowTopOffset + modalProductChoosePadding,
            'maxHeight.px': modalBtnShowTopOffset + modalProductChoosePadding,
            'left.px': modalBtnShowLeftOffset - modalProductChoosePadding,
            'width.px': modalBtnShowWidth + 2 * modalProductChoosePadding,
            'maxWidth.px': modalBtnShowWidth + 2 * modalProductChoosePadding,
            overflow: 'hidden',
          }
        : isModalForStatsSearch
          ? {
              position: 'fixed',
              'top.px': modalBtnShowTopOffset - 50,
              'height.px': availableHeight,
              'maxHeight.px': 434,
              'left.px': modalBtnShowLeftOffset - modalProductChoosePadding,
              'width.px': modalBtnShowWidth + 2 * modalProductChoosePadding,
              'maxWidth.px': modalBtnShowWidth + 2 * modalProductChoosePadding,
              overflow: 'hidden',
            }
          : undefined
    "
  >
    <div class="modal-content">
      <div class="modal-header" [class]="modalHeaderBgColorClass">
        <h4 class="modal-title" *ngIf="!isModalForProductChoose && !isModalForStatsSearch && !hasCustomHeader">
          <span *ngIf="translateTitle">
            {{ headerTitle | translate }}
            <ng-container *ngIf="headerTitleAfterTranslatedTitle && headerTitleAfterTranslatedTitle.length > 0">
              {{ headerTitleAfterTranslatedTitle }}
            </ng-container>
          </span>
          <span *ngIf="!translateTitle">{{ headerTitle }}</span>
        </h4>
        <button
          *ngIf="!isModalForProductChoose && !isModalForStatsSearch && !hasCustomHeader"
          data-cy="close"
          type="button"
          class="close"
          aria-label="Close"
          (click)="hideChildModal()"
          [title]="'close' | translate"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <ng-content select=".modal-header-content"> </ng-content>
      </div>
      <div class="modal-body" [ngClass]="{ 'p-0': noPaddingModalBody }" [class]="modalBodyBgColorClass">
        <loading-spinner [isLoading]="isLoading" [classesString]="'top-50'"></loading-spinner>
        <ng-content select=".modal-body-content"> </ng-content>
      </div>
      <div class="modal-footer" [class]="modalFooterBgColorClass">
        <btn
          [ngClass]="isHideBtnHidden ? 'd-none' : ''"
          [btnType]="'button'"
          [classes]="['btn-third']"
          (click)="hideChildModal()"
          [label]="'close'"
          [title]="'close' | translate"
          [icon]="'far-ban'"
        ></btn>
        <ng-content select=".modal-footer-content"> </ng-content>
      </div>
    </div>
  </div>
</div>
